export const FIND_TABLE_COLUMNS_CONFIG_FOR_USER_SUCCESS = 'FIND_TABLE_COLUMNS_CONFIG_FOR_USER_SUCCESS';

export const findTableColumnsConfigForUserSuccess = ({ tableColumns, tableKey }) => ({
    type: FIND_TABLE_COLUMNS_CONFIG_FOR_USER_SUCCESS,
    payload: {
        tableColumns,
        tableKey
    },
});
